import { defineStore } from 'pinia';

export const useModalStore = defineStore('modal', {
  state: () => ({
    isOpen: false,
    params: {},
    name: null,
    scrollable: false,
    size: 'xl'
  }),
  actions: {
    openDialog(name, params = {}, size = 'xl', scrollable = false) {
      this.params = params;
      this.name = name;
      this.size = size;
      this.scrollable = scrollable;
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
      this.name = null;
      this.params = {};
    },
    refreshDialog(modalId, updateParamsFn = {}) {
      if (modalId === this.params.modalId) {
        this.params = updateParamsFn(this.params);
      }
    },
  }
});
